import { Grid, Box, Skeleton } from "@mui/material";

export const SkeletonNotaFiscal = () => (
  <Grid container spacing={2}>
    {/* Cabeçalho */}
    <Grid size={{xs: 12}}>
      <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
        <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid size={{xs: 12, md: 4}}>
            <Skeleton variant="text" width="40%" height={25} />
            <Skeleton variant="rectangular" height={40} sx={{ mt: 0.5, borderRadius: 1 }} />
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Skeleton variant="text" width="40%" height={25} />
            <Skeleton variant="rectangular" height={40} sx={{ mt: 0.5, borderRadius: 1 }} />
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Skeleton variant="text" width="40%" height={25} />
            <Skeleton variant="rectangular" height={40} sx={{ mt: 0.5, borderRadius: 1 }} />
          </Grid>
        </Grid>
      </Box>
    </Grid>

    {/* Dados do Emitente/Destinatário */}
    <Grid container spacing={2} size={{xs: 12, md: 6}}>
      <Grid size={{xs: 12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper', height: '100%' }}>
          <Skeleton variant="text" width="40%" height={30} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 1 }} />
        </Box>
      </Grid>
    </Grid>

    <Grid container spacing={2} size={{xs: 12, md: 6}}>
      <Grid size={{xs: 12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper', height: '100%' }}>
          <Skeleton variant="text" width="40%" height={30} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 1 }} />
        </Box>
      </Grid>
    </Grid>

    {/* Itens da Nota */}
    <Grid size={{xs: 12}}>
      <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
        <Skeleton variant="text" width="30%" height={35} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 1 }} />
      </Box>
    </Grid>

    {/* Totais */}
    <Grid size={{xs: 12, md: 4}} ml="auto">
      <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
        <Skeleton variant="text" width="50%" height={30} sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Skeleton variant="text" width="30%" height={25} />
          <Skeleton variant="text" width="20%" height={25} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Skeleton variant="text" width="40%" height={25} />
          <Skeleton variant="text" width="20%" height={25} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Skeleton variant="text" width="30%" height={30} />
          <Skeleton variant="text" width="30%" height={30} />
        </Box>
      </Box>
    </Grid>
  </Grid>
);
